import { tableCellClasses, tableRowClasses, typographyClasses } from '@mui/material';
// TODO: to delete redundant comments later
export const MuiTableContainer = {
    styleOverrides: {
        root: ({ theme }) => ({
            color: theme.palette.text.muted,
            // A table with `useWindowScroll` is scrolled by the page, and react-virtuoso marks it with this attribute.
            // Without this rule such a table would also get its own vertical scrollbar, next to the page one.
            '&:has([data-viewport-type="window"])': {
                overflowY: 'hidden',
            },
        }),
    },
};
export const MuiTable = {
    variants: [
        {
            props: { size: 'large' },
            style: {
            // See `sizeLarge` below.
            // padding: theme.spacing(4),
            },
        },
    ],
    styleOverrides: {
        root: {
            letterSpacing: '-.025em',
        },
    },
};
export const MuiTableHead = {
    styleOverrides: {
        root: ({ theme }) => ({
            [`.${tableCellClasses.head}`]: {
                backgroundColor: theme.palette.common.white,
                ...theme.applyStyles('dark', {
                    backgroundColor: theme.palette.background.light,
                }),
                borderTop: 0,
                // `>` - is very important here! It prevents override `color` prop in other nested components existed in table head.
                [`> .${typographyClasses.root}`]: {
                    color: theme.palette.text.muted,
                },
            },
        }),
    },
};
export const MuiTableRow = {
    styleOverrides: {
        root: ({ theme }) => ({
            // Checkbox inside table cell is not so close to the top of a cell if verticalAlign is 'text-top' instead of 'top'.
            // verticalAlign: 'text-top',
            verticalAlign: 'top',
            // Return if Mui default 'border-bottom' lined behavior is gonna be used.
            //'&:last-child td, &:last-child th': { border: 0 },
            [`&.${tableRowClasses.hover}:hover`]: {
                // backgroundColor: alpha(theme.palette.text.primary, 0.015), // .025 tailwind Catalyst
                backgroundColor: `color-mix(in oklab, ${theme.vars.palette.text.primary} 1.5%, transparent)`, // .025 (2.5%) tailwind Catalyst
            },
        }),
        // not working but it should (working variant now with '&.MuiTableRow-hover:hover')
        // hover: ({ ownerState, theme }) => ({
        // 	'&:hover': {
        // 		backgroundColor: 'red',
        // 	},
        // }),
        head: ({ theme }) => ({
            backgroundColor: theme.palette.background.light,
        }),
    },
};
export const MuiTableCell = {
    styleOverrides: {
        root: ({ theme }) => ({
            borderBottomWidth: 0,
            borderTopWidth: '1px',
            borderTopStyle: 'solid',
            borderTopColor: theme.palette.dividerTranslucent,
            backgroundColor: 'inherit',
            color: 'inherit',
            // TODO: make default color `text.muted`, and fix GP <TableCell> from Core, also.
            // color: theme.palette.text.muted,
            // '.MuiTableBody-root > .MuiTableRow-root:first-of-type > &, .MuiTableHead-root > .MuiTableRow-root:first-of-type > &': {
            // '.MuiTableRow-root:first-of-type > &': {
            [`.${tableRowClasses.root}:first-of-type > &`]: {
                borderTopColor: theme.palette.divider,
            },
            [`&.${tableCellClasses.head}`]: {
                // padding: theme.spacing(2, 4), // this is not working
                paddingTop: theme.spacing(2),
                paddingBottom: theme.spacing(2),
            },
        }),
        sizeLarge: ({ theme }) => ({
            fontSize: theme.typography.body1.fontSize,
            padding: theme.spacing(4),
        }),
        sizeMedium: ({ theme }) => ({
            fontSize: theme.typography.body1.fontSize,
            // padding: '6px 16px', // old spacing TODO: to delete later
            padding: theme.spacing(2, 4),
        }),
        sizeSmall: ({ theme }) => ({
            fontSize: theme.typography.caption.fontSize,
            padding: '.25rem 0.875rem', // 4px 14px
        }),
        sizeExtraSmall: ({ theme }) => ({
            fontSize: theme.typography.helper.fontSize,
            // padding: '3px 7px',
            padding: theme.spacing(2, 1.5), // (4px, 6px)
            // [`&.${tableCellClasses.head}`]: {
            // 	padding: '.51rem 7px',
            // },
        }),
    },
};
